import { Plan } from '../../graphql/generated/api-graphql'
import { getService } from '../../helpers/ReduxHelpers'

export const plansService = getService<'plans', Plan[], null>('plans')
export const planService = getService<'plan', Plan, { id: string }>('plan')
